import { render, staticRenderFns } from "./tree_root.vue?vue&type=template&id=99900472&"
import script from "./tree_root.vue?vue&type=script&lang=js&"
export * from "./tree_root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports